"use client";

import { useState } from "react";
import { ShoppingCart, Check } from "lucide-react";
import { useCartStore } from "@/store/cart.store";
interface QuickAddProduct {
  id: string;
  name: string;
  price: number;
  dealerPrice?: number | null;
  coverImageUrl?: string;
  slug: string;
  stock: number;
  trackStock: boolean;
}

interface QuickAddButtonProps {
  product: QuickAddProduct;
  onAdd?: (btnRef: HTMLButtonElement) => void;
}

export function QuickAddButton({ product, onAdd }: QuickAddButtonProps) {
  const addItem = useCartStore((s) => s.addItem);
  const items   = useCartStore((s) => s.items);
  const [added, setAdded] = useState(false);

  const cartQty   = items.find((i) => i.productId === product.id && !i.variantId)?.quantity ?? 0;
  const remaining = product.trackStock ? Math.max(0, product.stock - cartQty) : Infinity;

  // Stok 0 ya da sepet stok limitine ulaştıysa butonu gösterme
  if (remaining <= 0) return null;

  const handleAdd = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    addItem({
      productId: product.id,
      name: product.name,
      price: product.price,
      dealerPrice: product.dealerPrice ?? null,
      imageUrl: product.coverImageUrl,
      quantity: 1,
      slug: product.slug,
      stock: product.stock,
      trackStock: product.trackStock,
    });

    onAdd?.(e.currentTarget);
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <button
      onClick={handleAdd}
      aria-label="Sepete ekle"
      className="absolute bottom-0 left-0 right-0 text-[11px] font-semibold py-3 uppercase tracking-widest flex items-center justify-center gap-1.5 sm:translate-y-full sm:group-hover:translate-y-0 transition-transform duration-300 ease-out"
      style={{ backgroundColor: "var(--sf-card-btn-bg)", color: "var(--sf-card-btn-text)", fontFamily: "var(--sf-font-heading)" }}
    >
      {added ? (
        <>
          <Check className="h-3.5 w-3.5 shrink-0" />
          Eklendi
        </>
      ) : (
        <>
          <ShoppingCart className="h-3.5 w-3.5 shrink-0" />
          Sepete Ekle
        </>
      )}
    </button>
  );
}
